<template>
  <CareTypeCardGroup :care-types="careTypes" :heading-text="'What type of care do you currently need?'" @select="saveCareType" />
</template>

<script lang="ts">
import { CareType } from '@/types/care_type';
import CareTypeCardGroup from '@/components/careType/CareTypeCardGroup.vue';
import { sendSegmentEventWithTimeout } from '@/lib/segment';
import OnboardingMutations from '@/graphql/onboarding/mutations';
import { redirectToJobPost } from '@/helpers/jobPostRedirect';

export default {
  name: 'CorporateCareTypeSelection',
  components: {
    CareTypeCardGroup,
  },
  data() {
    return {
      selectedCareType: '',
    };
  },
  computed: {
    corporateCareTypeTitles(): string[] {
      return ['CHILD_CARE', 'COMPANION_CARE', 'PET_CARE', 'SPECIAL_NEEDS', 'HOUSEKEEPING'];
    },
    careTypes(): string[] {
      return this.corporateCareTypeTitles;
    },
  },
  methods: {
    async saveCareType(careType: CareType | 'CHILD_CARE') {
      this.selectedCareType = careType;
      try {
        await this.$apollo.mutate({
          mutation: OnboardingMutations.COMPLETE_CARE_TYPE_TASK,
          variables: { careType: this.selectedCareType === 'CHILD_CARE' ? 'BABYSITTER' : this.selectedCareType },
        });
        await sendSegmentEventWithTimeout('Care Type Selected', { care_type: this.selectedCareType });
        redirectToJobPost(this.selectedCareType as CareType | 'CHILD_CARE', this.$router, {
          return_path: '/corporate-onboarding/care-type',
          source: 'corporate-onboarding',
          query: { ...this.$route.query },
        });
      } catch (_error) {
        this.handleError();
      }
    },
    handleError() {
      this.$router.push('/something-went-wrong?retry=true');
    },
  },
};
</script>
